module.exports = __webpack_public_path__ + "static/media/December2020Newsletter.8b8af18c.pdf";